// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api.dev-a93fj10w.ontariosecuritylicense.ca/v1/',
  googleOAuthClientId: '1094998117677-jiivqp4c1m81qdqcng5715qks9jr7pfe.apps.googleusercontent.com',
  stripePublishableKey: 'pk_test_51LkXeWFOL7gdXuKGyfOgvu0YYiZL2rvzARnmslH57OVfEYncMdJTVPoVcKOzMMi50SpueID77i9WNXXZc2JxzC9300IF7w3u9H',
  googleAPIKey: 'AIzaSyCRaRHWTcibdP2nCwq3lb9h9fCg27meKSk',
  forcePromo: false,
  forceMultiPromo:false

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
